import { Box, Button, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class CambioPassword extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            cambio: {
                password: '',
                passwordConfirmada: '',
            },
            passwordIguales: false,
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioCambio = this.manejarEnvioCambio.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    {sessionStorage.login
                    ?
                        <div className='mt-5'>
                            <h3 className='text-center'>CAMBIO PASSWORD</h3>
                            <hr />
                            <div className='row justify-content-center'>
                                <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                    <form onSubmit={this.manejarEnvioDatos}>
                                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <input type="password" className='form-control mb-2' placeholder='INGRESE NUEVA CONTRASEÑA' id='password' onChange={this.controlarCambios} value={this.state.cambio.password}/>
                                        <input type="password" className='form-control mb-2' placeholder='CONFIRMAR NUEVA CONTRASEÑA' id='passwordConfirmada' onChange={this.controlarCambios} value={this.state.cambio.passwordConfirmada}/>
                                        {this.state.passwordIguales ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCambio}>Confirmar</button> : null}
                                    </form>
                                </div>
                            </div>
                        </div>
                    :
                        <Redirect to='/inicio'/>
                    }
                </Container>
            </>
        )
    }

    controlarCambios(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.cambio;
            registroActualizado[clave] = valor;
            return{
                cambio: registroActualizado,
            };
        })
        if((this.state.cambio.password === valor)){
            this.setState({
                passwordIguales: true,
            });
        }else{
            this.setState({
                passwordIguales: false,
            });
        }
    }

    async manejarEnvioCambio(e){
        e.preventDefault();
        if((this.state.cambio.password === '')){
            this.setState({
                errores: 'Debe ingresar la nueva contraseña',
            })
        }else if((this.state.cambio.passwordConfirmada === '')){
            this.setState({
                errores: 'Debe confirmar la cntraseña',
            })
        }else if((this.state.cambio.password !== this.state.cambio.passwordConfirmada)){
            this.setState({
                errores: 'Las contraseñas deben ser iguales',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.cambio, sessionStorage.numeroFuncionario]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/cambio_password.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'La contraseña fue actualizada correctamente',
                    cambio: {
                        password: '',
                        passwordConfirmada: '',
                    },
                    passwordIguales: false,
                })
            }
        }
    }
}

export default CambioPassword